export const EMPTY_ARR = [];

export * from './ballTypes';
export * from './ballColors';
